// Shared canvas-text helpers.

// Binary-search the longest prefix of `text` that fits within `maxW` px under
// the context's CURRENT font, appending an ellipsis when it has to truncate;
// returns the text untouched when it already fits. Callers must set `ctx.font`
// before calling. Extracted from DotGrid so every canvas renderer shares one
// implementation (the composition bar used to carry a near-identical copy).
export function truncateToWidth(ctx, text, maxW) {
  if (!text) return "";
  if (ctx.measureText(text).width <= maxW) return text;
  const ellipsis = "...";
  if (ctx.measureText(ellipsis).width > maxW) return "";
  let lo = 0;
  let hi = text.length;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (ctx.measureText(text.slice(0, mid) + ellipsis).width <= maxW) lo = mid;
    else hi = mid - 1;
  }
  return text.slice(0, lo) + ellipsis;
}
